(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"]) return;
  try {
    
  const initializeRecipeFilters = (scope = document) => {
    scope.querySelectorAll('[data-recipe-filter-bar]').forEach((filterBar) => {
      if (filterBar.dataset.initialized === 'true') return;
      filterBar.dataset.initialized = 'true';
      const hub = filterBar.closest('.or-recipe-hub');
      const grid = hub?.querySelector('[data-recipe-grid]');
      const count = filterBar.querySelector('[data-recipe-count]');
      const buttons = [...filterBar.querySelectorAll('[data-recipe-filter]')];
      const cards = grid ? [...grid.querySelectorAll('[data-recipe-category]')] : [];
      const productSearch = hub?.querySelector('[data-recipe-product-search]');
      const productInput = productSearch?.querySelector('[data-recipe-product-input]');
      const productOptions = productSearch?.querySelector('[data-recipe-product-options]');
      const productClear = productSearch?.querySelector('[data-recipe-product-clear]');
      const productStatus = productSearch?.querySelector('[data-recipe-product-status]');
      const productIndex = hub?.querySelector('[data-recipe-product-index]');
      const emptyState = hub?.querySelector('[data-recipe-empty]');
      if (!grid || !count || buttons.length === 0 || !productInput || !productOptions || !productClear || !productStatus || !productIndex) return;

      const products = window.OlivinoRecipeProductIndex?.products || [];
      if (products.length === 0) productSearch.hidden = true;

      const normalizeValue = (value) => value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

      products.forEach((product) => {
        const option = document.createElement('option');
        option.value = product.title;
        option.label = product.group;
        productOptions.appendChild(option);
      });

      let activeCategory = 'all';
      let activeProduct = null;

      const resolveProduct = (value) => {
        const needle = normalizeValue(value);
        if (!needle) return null;
        const exact = products.find((product) => normalizeValue(product.title) === needle || product.handle === needle);
        if (exact) return exact;
        const partial = products.filter((product) => normalizeValue(product.title).includes(needle));
        return partial.length === 1 ? partial[0] : null;
      };

      const updateProductStatus = () => {
        productClear.hidden = productInput.value.trim() === '';
        if (activeProduct) {
          productStatus.textContent = productStatus.dataset.selected.replace('__PRODUCT__', activeProduct.title);
        } else if (productInput.value.trim() !== '') {
          productStatus.textContent = productStatus.dataset.prompt;
        } else {
          productStatus.textContent = productStatus.dataset.default;
        }
      };

      const applyFilters = (updateUrl = true) => {
        let visibleCount = 0;
        const matchingRecipes = activeProduct ? new Set(activeProduct.recipes) : null;
        cards.forEach((card) => {
          const categoryMatches = activeCategory === 'all' || card.dataset.recipeCategory === activeCategory;
          const productMatches = !matchingRecipes || matchingRecipes.has(card.dataset.recipeHandle);
          const visible = categoryMatches && productMatches;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.recipeFilter === activeCategory)));
        const label = visibleCount === 1 ? count.dataset.singular : count.dataset.plural;
        count.textContent = `${visibleCount} ${label}`;
        if (emptyState) emptyState.hidden = visibleCount !== 0;
        updateProductStatus();
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (activeCategory === 'all') url.searchParams.delete('recipe');
          else url.searchParams.set('recipe', activeCategory);
          if (activeProduct) url.searchParams.set('product', activeProduct.handle);
          else url.searchParams.delete('product');
          window.history.replaceState({}, '', url);
        }
      };

      buttons.forEach((button) => button.addEventListener('click', () => {
        activeCategory = button.dataset.recipeFilter;
        applyFilters();
      }));

      productInput.addEventListener('input', () => {
        activeProduct = resolveProduct(productInput.value);
        applyFilters();
      });

      productInput.addEventListener('change', () => {
        activeProduct = resolveProduct(productInput.value);
        if (activeProduct) productInput.value = activeProduct.title;
        applyFilters();
      });

      productClear.addEventListener('click', () => {
        productInput.value = '';
        activeProduct = null;
        applyFilters();
        productInput.focus();
      });

      const parameters = new URL(window.location.href).searchParams;
      const requestedCategory = parameters.get('recipe');
      if (buttons.some((button) => button.dataset.recipeFilter === requestedCategory)) activeCategory = requestedCategory;
      const requestedProduct = parameters.get('product');
      activeProduct = products.find((product) => product.handle === requestedProduct) || null;
      if (activeProduct) productInput.value = activeProduct.title;
      applyFilters(false);
    });
  };

  initializeRecipeFilters();
  document.addEventListener('shopify:section:load', (event) => initializeRecipeFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-or-gift-order]').forEach((giftOrder) => {
      if (giftOrder.dataset.orGiftBound === 'true') return;
      giftOrder.dataset.orGiftBound = 'true';

      const toggle = giftOrder.querySelector('[data-or-gift-toggle]');
      const message = giftOrder.querySelector('[data-or-gift-message]');
      const status = giftOrder.querySelector('[data-or-gift-status]');
      let saveTimer;

      const saveGiftDetails = () => {
        window.clearTimeout(saveTimer);
        status.textContent = giftOrder.dataset.savingLabel;

        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: { 'Gift order': toggle.checked ? 'Yes' : '' },
            note: message.value
          })
        })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to save gift details');
            status.textContent = giftOrder.dataset.savedLabel;
          })
          .catch(() => {
            status.textContent = giftOrder.dataset.errorLabel;
          });
      };

      toggle.addEventListener('change', saveGiftDetails);
      message.addEventListener('input', () => {
        window.clearTimeout(saveTimer);
        saveTimer = window.setTimeout(saveGiftDetails, 700);
      });
      message.addEventListener('blur', saveGiftDetails);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
